/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

/**
 * Type of action context
 */
export enum ContextAction {
  FOLLOW_AUTHOR = 'FOLLOW_AUTHOR',
  NOTIFY_ME = 'NOTIFY_ME',
}
